module.exports = __webpack_public_path__ + "img/comstream.964f2b95.svg";